// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gs-0";
export var actionModalContentContainer = "_gs-1";
export var createTagButton = "_gs-2";
export var footerContainer = "_gs-7";
export var fullWidthDivider = "_gs-3";
export var hasCreateTagButton = "_gs-4";
export var noCreateTagButton = "_gs-5";
export var tagsContainer = "_gs-6";
export var tagsModalContentContainer = "_gs-8";